import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LayoutElementBasedCarousel } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/LayoutElementBasedCarousel";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { useBestsellerProductsQuery } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/DataFetching/useBestsellerProductsQuery";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import * as React from "react";
import { ProductTileImpressionProvider } from "../__internal__/ProductTileImpressionsProvider";
export var BestsellerProductsCarousel = function() {
    var _useBestsellerProductsQuery = useBestsellerProductsQuery(), bestsellerProductsElement = _useBestsellerProductsQuery.bestsellerProductsElement, requestId = _useBestsellerProductsQuery.requestId, isFetching = _useBestsellerProductsQuery.isFetching;
    var isTablet = useViewport().isTablet;
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var headerRef = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("bestseller_products_carousel-header", "".concat(homepageRedesignVariant));
    });
    if (isFetching) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-[400px] items-center justify-center lg:h-[429px] xl:h-[480px] 2xl:h-[578px]",
            children: /*#__PURE__*/ _jsx(LoadingSpinner, {})
        });
    }
    if (!bestsellerProductsElement || !requestId) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SlideIn, {
        offset: getSpacing("3x"),
        children: /*#__PURE__*/ _jsx("div", {
            ref: headerRef,
            className: "relative overflow-hidden p-8 px-0 md:p-8 lg:p-12",
            children: /*#__PURE__*/ _jsxs(ProductTileImpressionProvider, {
                requestId: requestId,
                onClickEventName: bestsellerProductsElement.on_click_event_name,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "pageHeaderSerifRegular",
                            xLargeAndAbove: "displaySSerifRegular",
                            xxLargeDesktop: "displayMSerifRegular"
                        },
                        className: "pl-4 md:pl-0",
                        children: bestsellerProductsElement.main_text
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "3x"
                    }),
                    /*#__PURE__*/ _jsx(LayoutElementBasedCarousel, {
                        layoutElement: bestsellerProductsElement,
                        requestId: requestId,
                        itemsPerSlide: {
                            mobileAndAbove: 2,
                            tabletAndAbove: 4,
                            desktopAndAbove: 5,
                            xLargeAndAbove: 6
                        },
                        onItemClick: function(_x, _y, productLink) {
                            trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("bestseller_products_carousel", productLink, "".concat(homepageRedesignVariant));
                        },
                        hideTitle: true,
                        arrowOffsetX: isTablet ? -8 : undefined,
                        className: "box-border",
                        recordAdImpression: true
                    })
                ]
            })
        })
    });
};
